import $ from 'jquery';
import Swiper from 'swiper';

function postersCarousel() {
	$(document).ready(function () {
		var mySwiper = new Swiper('.js-posters-carousel', {
			speed: 400,
			pagination: {
				el: '.posters-carousel__pagination',
				type: 'fraction',
			},
			navigation: {
				nextEl: '.js-posters-carousel-prev',
				prevEl: '.js-posters-carousel-next',
			},
		});
	});
}

export default postersCarousel;



// WEBPACK FOOTER //
// ./app/blocks/posters-carousel/posters-carousel.js